import { Button, Heading } from "@elaniintc/goes-design-system";

interface EmptyStateProps {
  onViewLabels: () => void;
}

export const EmptyState = ({ onViewLabels }: EmptyStateProps) => {
  return (
    <div className="flex flex-col justify-center items-center h-[50vh]">
      <div className="flex flex-col items-center gap-2 max-w-[520px]">
        <Heading variant="h5" color="quiet" className="text-center">
          No existen procesos con etiquetas
        </Heading>
        <p className="text-body-quiet leading-3xl !text-center">
          Ve a la sección de recursos y añade procesos a tus etiquetas para
          categorizarlos.
        </p>
        <Button variant="tertiary" size="sm" onClick={onViewLabels}>
          Ver etiquetas
        </Button>
      </div>
    </div>
  );
};
